import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlankPageLandscape: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlankPageLandscape"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H8.03571C7.11036 20 6.21024 19.6988 5.47046 19.1421C3.28523 17.4977 2 14.9176 2 12.1786V4ZM8.40278 18.5C7.95491 18.5 7.67294 18.3509 7.47649 18.1446C7.26297 17.9204 7.10109 17.5737 7.02165 17.122C6.85834 16.1935 7.09036 15.104 7.4858 14.5088L7.82493 13.9984L6.29151 12.4598C4.50443 10.6667 3.5 8.23412 3.5 5.69717V5.5H20.5V18.5H8.40278Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlankPageLandscape;
